import { LIST_TYPES, ListType } from 'constants/listTypes';

export const ALL_LIST_TYPES: ListType[] = [
  LIST_TYPES.DYNAMIC,
  LIST_TYPES.STANDARD,
  LIST_TYPES.INTERNAL,
  LIST_TYPES.SUPPRESSION,
];

export const ALL_BUT_DYNAMIC_LIST_TYPES: ListType[] = [
  LIST_TYPES.STANDARD,
  LIST_TYPES.INTERNAL,
  LIST_TYPES.SUPPRESSION,
];

export type ListData = {
  id: string;
  name: string;
  updatedAt?: number;
};

export type ListOption = {
  id: string;
  label: string;
  doubleLine: string;
  value: string;
};
